export default {
      id: "social-instagram-usage",
      viewBox: "0 0 512 512",
      url: "/dist/svg/" + "sprite.svg#social-instagram-usage",
      toString: function () {
        return this.url;
      }
    }